import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { ref, reactive, onMounted, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import apis from "@/api";
import AuditState from "../components/AuditState";
import common from "../composables/common";
import download from "@/utils/download";
import UpLoad from "../components/UpLoad";
import SrcAudit from "../components/SrcAudit";
import DetailAside from "../components/DetailAside";
import SetDesigner from "../components/SetDesigner";
import { srcType } from "@/utils/srcType";
import SensitiveWordsDialog from "../components/SensitiveWordsDialog";
export default {
  components: {
    SensitiveWordsDialog,
    SetDesigner,
    DetailAside,
    SrcAudit,
    UpLoad,
    AuditState
  },
  name: "AccountSetting",
  setup(props, context) {
    const asideRef = ref(null);
    const {
      initUserInfo,
      getSrcType,
      getSrcState,
      srcAuditRoles,
      getRolesOfLogin,
      commonData,
      getDesignCompanies
    } = common();
    const handleDownload = row => {
      window.open(row.srcInnUrl);
    };
    const route = useRoute();
    const router = useRouter();
    const data = reactive({
      srcType: srcType,
      designer: {},
      roles: [],
      loading: false,
      uploadData: {},
      multiSelected: [],
      multiSrss: [],
      auditSrss: [],
      srcsLength: 0,
      imgUrl: '',
      srcTyp: 1,
      fileList: [],
      roleName: '123',
      auditRole: {},
      fileDialogShow: false,
      auditDialogShow: false,
      setDesignerDialogShow: false,
      previewShow: false,
      checked: "",
      demandId: route.query.demandId,
      demand: {},
      positions: [],
      scores: []
    });
    const loadDemand = () => {
      apis.getDemandById({
        id: data.demandId
      }).then(res => {
        if (res.success) {
          data.demand = res.data;
          const validDate = [res.data.validDateBgn, res.data.validDateEnd];
          data.demand.validDate = validDate;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const loadSrcs = () => {
      data.loading = true;
      apis.getSrcsById({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.positions = res.data;
          data.multiSelected = new Array(data.positions.length);
          data.positions.forEach(p => {
            data.srcsLength += p.srcs.length;
            // 查询运营位信息
            apis.queryPositionById(p.positionId).then(res => {
              if (res.success) {
                p.picFileSize = res.data.picFileSize;
                p.picSize = res.data.picSize;
                p.srcTyp = res.data.srcTyp;
                p.srcTypSuffix = res.data.srcTypSuffix;
              } else {
                ElMessage.error(res.msg);
              }
            });
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        asideRef.value.refresh();
        data.loading = false;
      });
    };
    const canAudit = () => {
      let can = false;
      // 业务审核
      if (data.auditRole.roleId === 'yewu') {
        if (data.demand.createrId === commonData.userInfo.userId) {
          can = true;
        }
      } else {
        for (let i = 0; i < commonData.roles.length; i++) {
          if (commonData.roles[i].roleId == data.auditRole.roleId) {
            can = true;
            break;
          }
        }
      }
      return can;
    };
    const showAuditDialog = (auditRole, row) => {
      data.auditRole = auditRole;
      data.auditSrss = [];
      if (row) {
        data.auditSrss.push(row);
      } else if (data.multiSrss.length > 0) {
        data.auditSrss = data.multiSrss;
      } else {
        ElMessage.error('请选择要审批的素材');
        return;
      }
      const src = data.auditSrss[0];
      src.approveInfos.forEach(appr => {
        if (appr.roleId === auditRole.roleId) {
          data.auditRole.aprroveContent = appr.aprroveContent;
        }
      });
      data.auditDialogShow = true;
      // // 权限校验
      // const can = canAudit()
      // if (can) {
      //   data.auditDialogShow = true
      // } else {
      //   ElMessage.error('您不具备' + auditRole.roleName + '审核权限')
      // }
    };
    const previewTypes = ".jpg,.jpeg,.bmp,.gif,.png";
    const showPreviewDialog = row => {
      if (previewTypes.indexOf(row.extension) > -1) {
        data.previewShow = true;
        data.imgUrl = row.srcInnUrl;
      } else {
        ElMessage.warning("文件类型「" + row.extension + "」无法预览!");
      }
    };
    const showFileDialog = p => {
      data.fileDialogShow = true;
      data.uploadData = {
        demandId: data.demandId,
        demandName: data.demand.name,
        bgnDate: data.demand.validDateBgn,
        endDate: data.demand.validDateEnd,
        positionId: p.positionId,
        positionTopId: p.topId,
        srcTyp: p.srcTyp,
        srcTypSuffix: p.srcTypSuffix,
        picSize: p.picSize,
        picFileSize: p.picFileSize
      };
    };
    const handleDelete = srcId => {
      apis.delSrcBySrcId({
        srcId
      }).then(res => {
        if (res.success) {
          loadSrcs();
          ElMessage({
            type: 'success',
            message: '删除成功'
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleInput = (row, p) => {
      apis.srcInput({
        srcId: row.srcId
      }).then(res => {
        if (res.success) {
          loadSrcs();
          ElMessage.success('素材入库成功');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const isAdmin = p => {
      let flag = false;
      for (let i = 0; i < p.admins.length; i++) {
        if (p.admins[i].userId == commonData.userInfo.userId) {
          flag = true;
          break;
        }
      }
      return flag;
    };
    const editDesignName = p => {
      data.setDesignerDialogShow = true;
      data.designer = p;
    };
    const handleSelectionChange = (val, i) => {
      data.multiSelected[i] = val;
      const multiSrss = [];
      data.multiSelected.forEach(m => {
        m.forEach(s => {
          multiSrss.push(s);
        });
      });
      data.multiSrss = multiSrss;
    };
    const selectable = (row, index) => {
      return row.state == 0;
    };
    const handlePressAudit = () => {
      if (data.multiSrss.length <= 0) {
        ElMessage.warning('请选择未审核的素材');
        return;
      }
      const sIds = data.multiSrss.map(s => s.srcId).join(',');
      apis.pressAudit({
        demandId: data.demandId,
        srcIds: sIds
      }).then(res => {
        if (res.success) {
          ElMessage.success('已成功催审核');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const canScore = p => {
      let can = false;
      if (commonData.userInfo.userId == p.designAccount) {
        // 如果是设计方，判断当前运营位是否已经评分
        for (let i = 0; i < data.scores.length; i++) {
          const s = data.scores[i];
          if (s.positionId = p.positionId && s.designAccount == p.designAccount) {
            can = true;
            break;
          }
        }
      } else {
        for (let i = 0; i < p.srcs.length; i++) {
          if (p.srcs[i].state == 2) {
            can = true;
            break;
          }
        }
      }
      return can;
    };
    const showScoreTable = p => {
      const params = {
        demandId: p.demandId,
        designAccount: p.designAccount,
        designName: p.designName,
        topId: p.topId,
        positionId: p.positionId
      };
      apis.getScoreTable(params).then(res => {
        if (res.success) {
          router.push({
            name: 'demand-' + res.data,
            query: params
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const loadScores = () => {
      apis.getScores({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.scores = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const toBack = () => {
      router.go(-1);
    };
    onMounted(() => {
      getDesignCompanies();
      getRolesOfLogin();
      loadDemand();
      loadSrcs();
      initUserInfo();
      loadScores();
      console.log("初始化查询开始------------");
    });
    return {
      ...toRefs(commonData),
      ...toRefs(data),
      srcAuditRoles,
      asideRef,
      loadDemand,
      loadSrcs,
      getSrcState,
      getSrcType,
      handleDelete,
      handleDownload,
      handleInput,
      showPreviewDialog,
      showFileDialog,
      showAuditDialog,
      editDesignName,
      handleSelectionChange,
      selectable,
      isAdmin,
      handlePressAudit,
      canScore,
      showScoreTable,
      toBack
    };
  }
};